// src/components/ProtectedRoute.js
import { Navigate } from 'react-router-dom';
import useAuthStore from '../store/authStore'; // adjust path if needed

export default function ProtectedRoute({ children }) {
  const access = useAuthStore((state) => state.access);

  return access ? children : <Navigate to="/" replace />;
}

